import React, { useState, useEffect } from "react";

/** Components */
import {
  TableContainer,
  TableHead,
  TextField,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
  TableFooter,
  Collapse,
  LinearProgress,
  ButtonGroup,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import ExtrptDetail from "./[id]";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";

/** Api & Function */
import { getExtrpt, getInventory, getOrganizationData, syncExtrpt } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParamFilter } from "../../commons/customHook";
import { convertQueryStringToObject } from "../../../services/libService";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ExtRptStatusOption } from "../../config";

const Extrpt = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const [t] = useTranslation();
  const { fetchData, data, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getExtrpt);
  const [isSearchOpen, setSearchOpen] = useState(true);
  //filter
  const filter = convertQueryStringToObject(location.search);
  const [input, setInput] = useState({
    start_date: filter.start_date || "",
    end_date: filter.end_date || "",
    vehicle: filter.vehicle || "",
    bill_order: filter.bill_order || "",
    status: null,
  });
  const [isOpen, setOpen] = useState(false);
  ////////
  const handleSyncResponse = (res) => {
    if (res.code !== 200) return;
    fetchData(filter);
    setOpen(false);
  };
  const handleSearch = () => {
    fetchData((prev) => ({ ...input, status: input.status?.label }));
  };

  // gọi lại api fetch để làm mới bảng sau khi duyệt
  const handleCreateResponse = () => {
    fetchData(filter);
  };
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN HÀNG GỬI TỪ KHO ĐẦU NGUỒN"));
    fetchData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={() => history.push("/report/rptimptruck")}>
            <Tooltip title="Bảng đối chiếu số lượng nhập hàng xe xi-tec">
              <AssessmentIcon />
            </Tooltip>
          </Button>
          <Button onClick={() => setOpen((prev) => !prev)}>
            <Tooltip title="Cập nhật dữ liệu từ kho đầu nguồn">
              <RefreshIcon />
            </Tooltip>
          </Button>
          <Button onClick={() => setSearchOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      <Collapse in={isSearchOpen}>
        <TextField
          label={t("Lệnh điều động số")}
          value={input.bill_order || ""}
          onChange={(e) => setInput((prev) => ({ ...prev, bill_order: e.target.value }))}
          style={{ margin: "5px" }}
          InputProps={{ style: { minWidth: "200px" } }}
        />
        <TextField
          label={t("Số xe")}
          value={input.vehicle || ""}
          onChange={(e) => setInput((prev) => ({ ...prev, vehicle: e.target.value }))}
          style={{ margin: "5px" }}
          InputProps={{ style: { minWidth: "200px" } }}
        />
        <FilterBy
          style={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
          label={t("Trạng thái")}
          getOptionLabel={(option) => t(option.label)}
          isOptionEqualToValue={(option, value) => option === value}
          getDataFunc={() => Promise.resolve({ data: ExtRptStatusOption, code: 200 })}
          value={input?.status || null}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, status: newValue }))}
          // eslint-disable-next-line eqeqeq
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, status: option.find((item) => item.label == filter.status) }))}
          triggerSetDefaultFunc={true}
          setDefaultDependencies={[filter.status]}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Từ ngày")}
          value={input.start_date}
          onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))}
          sx={{ minWidth: "200px", margin: "5px" }}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Đến ngày")}
          value={input.end_date}
          onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))}
          sx={{ minWidth: "200px", margin: "5px" }}
        />
        <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
          {t("Tìm kiếm")}
        </Button>
      </Collapse>

      {loading ? (
        <LinearProgress style={{ position: "fixed", bottom: 0, width: "100%" }} />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Ngày")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Lệnh điều động số")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Kho xuất")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>Loại vận tải</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Biển số xe")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Lít")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("L15")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("USG")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("KG")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Số PXKKVCNB")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length ? (
                data.map((row, index) => (
                  <TableRow key={row.id} hover style={{ cursor: "pointer" }} onClick={() => history.push(`/extrpt/${row.id}${location.search}`)}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{moment(row.bill_order_date).format("DD/MM/YYYY")}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.bill_order}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.inventory}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.loadingtype}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.truck_no}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.lit?.toLocaleString()}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.l15?.toLocaleString()}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.usg?.toLocaleString()}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.kg?.toLocaleString()}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.receipt_code}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={50}>{t(isAllow ? "Không có dữ liệu" : "No permission")}</TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
      <SyncDialog open={isOpen} onClose={() => setOpen(false)} onSyncResponse={handleSyncResponse} />
      <ExtrptDetail onCreateResponse={handleCreateResponse} onClose={() => history.push(`/extrpt${location.search}`)} />
    </div>
  );
};
const SyncDialog = ({ onClose, open, onSyncResponse }) => {
  const user = useSelector((state) => state.user.data);
  const { t } = useTranslation();
  const [input, setInput] = useState({
    organization: null,
    inventory: null,
    date: "",
  });
  // method
  const handleClick = () => {
    return syncExtrpt({
      organization_id: input.organization?.id,
      inventory_id: input.inventory?.id,
      date: input.date,
    });
  };
  return (
    <Dialog open={Boolean(open)} onClose={onClose} maxWidth={false}>
      <DialogTitle align="center">{t("Chọn thông tin đồng bộ dữ liệu")}</DialogTitle>
      <DialogContent>
        <div style={{ display: "grid", rowGap: 10, marginTop: 10 }}>
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 500 }}
            disabled={Boolean(user?.organization_id !== 1)}
            getDataFunc={() => getOrganizationData({ status: 1 })}
            value={input.organization || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, organization: newValue, inventory: null }))}
            label={t("Tổ chức")}
            // eslint-disable-next-line eqeqeq
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, organization: option.find((item) => item.id == user.organization_id) }))}
            triggerSetDefaultFunc={Boolean(user?.organization_id !== 1)}
            setDefaultDependencies={[user]}
          />
          <FilterBy
            style={{ display: "inline-flex", margin: "5px", minWidth: 500 }}
            getDataFunc={() => getInventory({ status: 1, organization_id: input.organization?.id })}
            // eslint-disable-next-line eqeqeq
            filter={(option) => option.whtype == 1}
            value={input.inventory || null}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, inventory: newValue }))}
            label={t("Kho đầu nguồn")}
            getDataDependencies={[input.organization]}
          />
          <CustomDatePicker
            format="DD/MM/YYYY"
            value={input.date}
            label={t("Ngày")}
            onChange={(value) => setInput((prev) => ({ ...prev, date: value }))}
            style={{ display: "inline-flex", margin: "5px", minWidth: "500px" }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICall variant="contained" api={handleClick} response={onSyncResponse}>
          {t("Xác nhận")}
        </ButtonWithAPICall>
      </DialogActions>
    </Dialog>
  );
};

export default Extrpt;
